interface DateRangePickerProps {
  from: string;
  to: string;
  onFromChange: (date: string) => void;
  onToChange: (date: string) => void;
}

export default function DateRangePicker({
  from,
  to,
  onFromChange,
  onToChange,
}: DateRangePickerProps) {
  return (
    <div className="flex items-center space-x-4">
      <div>
        <label htmlFor="from-date" className="block text-sm font-medium text-gray-700">
          From
        </label>
        <input
          type="date"
          id="from-date"
          value={from}
          onChange={(e) => onFromChange(e.target.value)}
          className="input mt-1"
        />
      </div>
      <div>
        <label htmlFor="to-date" className="block text-sm font-medium text-gray-700">
          To
        </label>
        <input
          type="date"
          id="to-date"
          value={to}
          onChange={(e) => onToChange(e.target.value)}
          className="input mt-1"
        />
      </div>
    </div>
  );
}
